'use strict';

const flyout = require('../../flyout'),
    stickyAddToCart = require('./stickyaddtocart'),
    outOfStock = require('./outOfStock'),
    productIngredient = require('./ingredient'),
    pdpAnimations = require('./pdp-animations'),
    option = require('./option'),
    productTile = require('../../product-tile'),
    video = require('../../video'),
    personalisedGifting = require('../personalisedgifting/personalise'),
    personalisedLightbox = require('../personalisedgifting/lightbox'),
    writeACard = require('../../write-a-card'),
    variations = require('./variations'),
    isSmallView = require('../../modules/helpers/isSmallView'),
    easter = require('../../easter/easter'),
    gtm = require('../../modules/google').tagManager,
    advent = require('../../advent');

const isPg = $('.js-pdp-main').hasClass('giftset-pdp-main-container');

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    $(document).on('click', '.js-check-instore-availabilty', function(){
        const $this = $(this);
        flyout.openInStoreAvailabilityFlyout($this.hasClass('js-amsterdam-availabilty'));
        $(this).addClass('js-flyout-opened');
        advent.pushAdventDataLayerDataWithActiveProductImageSlide('instore availability');
    });

    $(document).on('click', '.js-check-instore-availabilty-hor', function(){
        const $this = $(this);
        flyout.openInStoreAvailabilityHORFlyout($this.hasClass('js-amsterdam-availabilty'));
        $(this).addClass('js-flyout-opened');
    });

    // on click "Read more" link, scroll to accordion
    $(document).on('click', '.js-read-more-link',function(){
        const $accordionEl = $('.js-product-tabs');
        const headerHeight = $('.js-header').height();
        const $descriptionAddcorion = $('.js-description-acc-head');
        const $descriptionTab = $('.js-description-tab');
        handleDataLayerEvents($(this));

        $('html,body').animate({
            scrollTop: $accordionEl.offset().top - headerHeight
        }, 1000);

        if (isSmallView()) {
            if (!$descriptionAddcorion.hasClass('open')){
                setTimeout(function () {
                    $descriptionAddcorion.trigger('click', [true]).focus();
                }, 600);
            }
        } else {
            if (!$descriptionTab.hasClass('selected')){
                setTimeout(function () {
                    $descriptionTab.trigger('click', [true]).focus();
                }, 600);
            }
        }
    });

    if (new URL(window.location.href).searchParams.get('origin') === 'gst_talisman') {
        gtm.pushDataLayerEvent({
            'origin': 'gst_talisman'
        });
    }

    function handleDataLayerEvents(target) {
        if (!target || !target.length) {
            return;
        }

        const analytics = target.data('analytics');
        if (!analytics) {
            return;
        }
        analytics.content_name = decodeURI(analytics.content_name); /* eslint-disable-line camelcase */
        analytics.click_target = decodeURI(analytics.click_target); /* eslint-disable-line camelcase */

        gtm.pushDataLayerEvent(analytics);
    }

    // Only on the Personalised Gifting page.
    // Sets the event handler to ask for confirmation when exiting the page
    if (isPg) {
        $(document).on('pgCustomize.onChange', function() {
            if ($('.js-card-message-textarea').val() != '' || $('.js-undo-button:visible').length > 0) {
                addBeforeUnloadEvent();
            } else {
                removeBeforeUnloadEvent();
            }
        });

        $(document).on('pgCustomize.onSubmit', function() {
            removeBeforeUnloadEvent();
        });
    }

    $('body').on('click', '.js-pdp-back',function() {
        const URL = $(this).data('url');
        if (URL) {
            const ref = document.referrer;
            if (ref === '' || ref.indexOf('rituals') === -1 || ref.indexOf('login') > -1 || ref.indexOf('outlet') === -1){
                window.location = URL;
                return;
            }
        }


        const $easterPDP = $(this).closest('.js-easter-pdp');
        if ($easterPDP && $easterPDP.length) {
            easter.pushEvent('back');
            if ($(this).hasClass('js-breadcrumbs-easter')) {
                $(document).trigger($.Event('easter.startCloseAnimation'));
                return;
            }
        }

        window.history.back();
    });
}

/**
 * Attaches the beforeunload event to the window object with the 'product'
 * namespacing
 */
function addBeforeUnloadEvent() {
    $(window).off('beforeunload.product').on('beforeunload.product', function() {
        return true;
    });
}

/**
 * Removes the beforeunload event from the window object using the 'product'
 * namespacing
 */
function removeBeforeUnloadEvent() {
    $(window).off('beforeunload.product');
}

/**
 * @description Lightweight event init for product quickviews
 */
function initializeQuickviewEvents() {
    option();
}

const product = {
    init: function () {
        initializeEvents();
        productTile.init();
        stickyAddToCart.init();
        outOfStock.init();
        productIngredient.init();
        video.initPDP();
        personalisedGifting.init();
        personalisedLightbox.init();
        writeACard.init();
        variations.initEvents();
    },

    initOnDomReady: function() {
        pdpAnimations.init();
    },

    initializeQuickviewEvents: initializeQuickviewEvents
};

module.exports = product;
